import { Injectable } from '@angular/core';
import { HttpRestService } from '@core/services/http-rest.service';
import { ApplicationsByEmail } from './typings/gdpr.typing';

@Injectable({ providedIn: 'root' })
export class GdprResources {

  constructor (
    private httpRestService: HttpRestService
  ) { }

  getApplicationsByEmail (email: string): Promise<ApplicationsByEmail> {
    const endpoint = 'api/manager/applications/ApplicationsByApplicantEmail';

    return this.httpRestService.post(endpoint, {
      email
    });
  }

  obfuscateApplicationsForApplicant (
    applicationIds: number[],
    email: string
  ) {
    const endpoint = 'api/manager/applications/ObfuscateApplicantData';

    return this.httpRestService.post(endpoint, {
      applicationIds,
      email
    });
  }

}
